module.exports = __webpack_public_path__ + "img/ui-radios-grid.35b355c7.svg";